import { GetTimelogsInput, PaginationInput } from '@/gql/graphql';

const timelogKeys = {
  all: ['timelogs'] as const,
  list: (input?: GetTimelogsInput, pagination?: PaginationInput) => {
    const baseKey = [...timelogKeys.all] as const;
    if (!input && !pagination) return baseKey;
    return [...baseKey, { input, pagination }] as const;
  },
};

export default timelogKeys;
